import { Theme } from '@blockanalitica/ui/package/types/src/theme/ThemeProvider';
import { ComponentStyle } from '@blockanalitica/ui/package/types/src/theme/types';

export function input(theme: Theme): ComponentStyle {
  return {
    componentName: 'input',
    baseStyle: {
      border: `1px solid ${theme.colors.border15}`,

      ['&:focus']: {
        outline: 'none',
        border: `1px solid ${theme.colors.border}`
      }
    }
  };
}
